import { C } from '../styles/tokens';

const RINGS = [140, 100, 68];
const BAR_COUNT = 22;

export default function BootLoadingScreen({ text = 'Initializing Dashboard' }) {
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 2000,
            background: '#FFFFFF',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            gap: 28,
        }}>
            <style>{`
                @keyframes l2i-boot-pulse {
                    0%, 100% { transform: translate(-50%,-50%) scale(1); opacity: .55; }
                    50% { transform: translate(-50%,-50%) scale(1.08); opacity: 1; }
                }
                @keyframes l2i-boot-wave { from { transform: scaleY(.22); } to { transform: scaleY(1); } }
                .l2i-boot-ring { animation: l2i-boot-pulse 2.4s ease-in-out infinite; }
                .l2i-boot-bar { animation-name: l2i-boot-wave; animation-timing-function: ease-in-out; animation-iteration-count: infinite; animation-direction: alternate; }

                @media (prefers-reduced-motion: reduce) {
                    .l2i-boot-ring, .l2i-boot-bar { animation: none !important; }
                    .l2i-boot-ring { opacity: .35; }
                    .l2i-boot-bar { transform: scaleY(.6) !important; }
                }
            `}</style>

            {/* Mic orb scene */}
            <div style={{ position: 'relative', width: 160, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {RINGS.map((s, i) => (
                    <div key={i} className="l2i-boot-ring" style={{
                        position: 'absolute', top: '50%', left: '50%',
                        width: s, height: s, borderRadius: '50%',
                        border: `1px solid rgba(37,99,235,${0.14 + i * 0.08})`,
                        transform: 'translate(-50%,-50%)',
                        animationDelay: `${i * 0.25}s`,
                    }} />
                ))}

                <div style={{
                    position: 'relative', zIndex: 2, width: 68, height: 68, borderRadius: '50%',
                    background: 'linear-gradient(135deg,#2563EB,#7C3AED)',
                    boxShadow: '0 0 32px rgba(99,102,241,.35)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round">
                        <rect x="9" y="2" width="6" height="13" rx="3" />
                        <path d="M5 10a7 7 0 0 0 14 0M12 19v3M8 22h8" />
                    </svg>
                </div>
            </div>

            {/* Waveform bars */}
            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', gap: 3, height: 34, marginTop: -14 }}>
                {Array.from({ length: BAR_COUNT }, (_, i) => (
                    <div key={i} className="l2i-boot-bar" style={{
                        width: 3, borderRadius: 2, transformOrigin: 'bottom',
                        background: 'linear-gradient(to top,#2563EB,#93C5FD)',
                        animationDuration: `${0.6 + ((i * 7) % 5) * 0.18}s`,
                        animationDelay: `${(i * 31) % 400}ms`,
                        height: `${10 + Math.abs(Math.sin(i * 0.65) * 20)}px`,
                    }} />
                ))}
            </div>

            <div style={{ fontSize: 14.5, fontWeight: 700, color: C.n700, letterSpacing: '-.005em', marginTop: 4 }}>
                {text}
            </div>
        </div>
    );
}
